import React, { Component } from "react";
import "./App.css";
import Form from "./Components/Form";

class App extends Component {
  render() {
    return (
      <div className="app-container">
        <Form></Form>
      </div>
    );
  }
}

export default App;
